module.exports = __webpack_public_path__ + "static/SL66-b96b42891e65e641c7c07ae5a6069706.png";